import { ThemeToggle } from "@/components/theme-toggle";
import { cn } from "@/lib/utils";
import { ScrollSpyNav } from "@/components/layout/ScrollSpyNav";

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b glass-morphism backdrop-blur-lg bg-white/60 dark:bg-black/30 transition-all supports-[backdrop-filter]:bg-white/30" role="banner">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-2">
          <a href="/" className="flex items-center space-x-2" aria-label="AVON BEARINGS - Home">
            <span className="text-2xl font-bold avon-gradient-text">AVON BEARINGS</span>
          </a>
        </div>
        <nav aria-label="Main navigation">
          <ScrollSpyNav />
        </nav>
        <div className="flex items-center gap-2">
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}

